import React, { useState } from 'react';
import GhlFormModal, { GHL_FORMS } from './GhlFormModal';

// The monthly workshop offer, used on Work With Me and Resources.
const MonthlyWorkshop: React.FC<{ id?: string }> = ({ id = 'monthly-workshop' }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <section className="section section--lavender" id={id}>
      <div className="container container--narrow">
        <h2>Monthly Hands-On Workshop: The Physiology of Productivity</h2>
        <p className="lead">
          Rereading the same ticket three times? Your best thinking gone by 2pm? Wired at midnight, wrecked at 9?{' '}
          <strong>That's not age. It's physiology, and it's fixable.</strong>
        </p>
        <p>
          <strong>45 minutes, live, hands-on.</strong> What you leave with:
        </p>
        <ul className="symptoms">
          <li>Why your focus dies at 2pm, and how to stop it before it does.</li>
          <li>How to stop lying awake with your brain still debugging, and wake up rested instead of wired.</li>
          <li>How to spot an overloaded nervous system before it turns into burnout.</li>
          <li>
            <strong>Live Q&amp;A:</strong> bring your biggest challenge, get a straight answer.
          </li>
        </ul>
        <p>
          <em>Every month. Register and I'll send you the date and the link.</em>
        </p>
        <button className="btn btn-primary" onClick={() => setIsOpen(true)}>
          Register
        </button>
      </div>
      <GhlFormModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        form={GHL_FORMS.workshop}
        title="Register for the Workshop"
        intro="The Physiology of Productivity: 45 minutes, live, with Q&A."
      />
    </section>
  );
};

export default MonthlyWorkshop;
